import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LabelledInput, SelectInput } from '@tg/core/components';
import { Control, Controller } from 'react-hook-form';
import { SelectOption } from '@tg/core/components/molecules/SelectInput/SelectInput';

interface Props {
  name: string;
  id: string;
  translationKey: string;
  required: boolean;
  disabled: boolean;
  control: Control;
  defaultValue: string;
  //   errors: PropTypes.object;
  options: SelectOption[];
  multiple?: boolean;
}

const SelectField: FC<Props> = ({
  required,
  name,
  disabled,
  defaultValue,
  translationKey,
  control,
  errors,
  options,
  multiple,
}) => {
  const { t } = useTranslation('forms');

  const label = t(`labels.${translationKey}`);
  const placeholder = t(`placeholders.${translationKey}`);

  let errorMessage = '';
  if (errors) {
    if (errors.message.key) {
      errorMessage = t(`validations.${errors.message.key}`);
    } else if (errors.type === 'required') {
      errorMessage = t(`validations.field_required`);
    }
  }

  return (
    <LabelledInput
      label={label}
      id={name}
      required={required && !disabled}
      error={errors && errorMessage}
    >
      <Controller
        name={name}
        as={props => (
          <SelectInput
            id={name}
            placeholder={placeholder}
            options={options}
            multiple={multiple}
            {...props}
          />
        )}
        control={control}
        defaultValue={defaultValue}
      />
    </LabelledInput>
  );
};

export default SelectField;
